import { fetchUserAttributes } from 'aws-amplify/auth';
import log from 'loglevel';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { useLocation } from 'react-router';

import { standardizeUser } from './UserContext';

import type { Location} from 'react-router';

const setGAUserId = (userId: string) => {
    log.info(`Setting userId to ${userId}`);
    ReactGA.set({ userId });
};

export const configGA = async (callback?: (attrs: unknown) => void) => {
    const attrs = await fetchUserAttributes();
    const standardUser = standardizeUser(attrs);
    setGAUserId(standardUser.attributes.sub);
    if (callback) callback(attrs);
};

export const initializeGA = () => {
    if (process.env.NODE_ENV === 'development') return;
    const measurementId = import.meta.env.VITE_GA4_MEASUREMENT_ID || 'G-2GG5QRP2ZV';
    ReactGA.initialize(measurementId, {
        gtagOptions: {
            siteSpeedSampleRate: 100,
            cookieFlags: 'SameSite=None;Secure',
        },
    });
};

const logPageView = (location?: Location) => {
    let page = window.location.pathname;
    if (location?.pathname) {
        page = location.pathname;
    }
    if (process.env.NODE_ENV === 'development') {
        log.info(`In prod would log page view for ${page}`);
    } else {
        ReactGA.send({ hitType: 'pageview', page });
        log.info(`Page View logged for: ${page}`);
    }
};

export const logModalView = (modalName: string) => {
    if (process.env.NODE_ENV === 'development') {
        log.info(`In prod would log modal view for ${modalName}`);
    } else {
        ReactGA.event({ category: 'Modal', action: 'view', label: modalName });
        log.info(`Modal View logged for: ${modalName}`);
    }
};

export const usePageViews = () => {
    const location = useLocation();
    useEffect(() => {
        logPageView(location);
    }, [location]);
};

